<template>
    <div class="card mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-1 indicator-title pr-0">
                    {{ indicator.section_number }}.{{ indicator.indicator_number }}
                </div>
                <div class="col-7 indicator-title pl-3">
                    {{ indicator.short_text }}
                </div>
                <div class="col-4 grade-badge px-1">
                    <span class="badge badge-dark">{{ initialIndicator.grade == '0' ? scoringLabels[0] : '' }}</span>
                    <span class="badge badge-danger">{{ initialIndicator.grade == '1' ? scoringLabels[1] + ' (1)' : '' }}</span>
                    <span class="badge badge-bronze">{{ initialIndicator.grade == '2' ? scoringLabels[2] + ' (2)' : '' }}</span>
                    <span class="badge badge-silver">{{ initialIndicator.grade == '3' ? scoringLabels[3] + ' (3)' : '' }}</span>
                    <span class="badge badge-gold">{{ initialIndicator.grade == '4' ? scoringLabels[4] + ' (4)' : '' }}</span>
                    <span class="badge-separator mx-1"> > </span>
                    <span class="badge badge-dark">{{ followupIndicator.grade == '0' ? scoringLabels[0] : '' }}</span>
                    <span class="badge badge-danger">{{ followupIndicator.grade == '1' ? scoringLabels[1] + ' (1)' : '' }}</span>
                    <span class="badge badge-bronze">{{ followupIndicator.grade == '2' ? scoringLabels[2] + ' (2)' : '' }}</span>
                    <span class="badge badge-silver">{{ followupIndicator.grade == '3' ? scoringLabels[3] + ' (3)' : '' }}</span>
                    <span class="badge badge-gold">{{ followupIndicator.grade == '4' ? scoringLabels[4] + ' (4)' : '' }}</span>
                </div>
            </div><!-- .row -->
            <div class="row mt-2">
                <div class="col-3 pl-4">
                    Intial Comments:
                </div>
                <div class="col-9">
                     {{ initialIndicator.comment }}
                </div>
            </div>
            <div v-if="[1,2,3].includes(initialIndicator.grade)">
                <div class="row mt-2">
                    <div class="col-3 pl-4">
                        Strategy:
                    </div>
                    <div class="col-9">
                         {{ planIndicator.strategy }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-3 pl-4">
                        Person Responsible:
                    </div>
                    <div class="col-9">
                         {{ planIndicator.person_responsible }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-3 pl-4">
                        Target Date:
                    </div>
                    <div class="col-3">
                         {{ formatDate(planIndicator.targeted_at) }}
                    </div>
                    <div class="col-3 pl-4">
                        Completion Date:
                    </div>
                    <div class="col-3">
                         {{ formatDate(planIndicator.completed_at) }}
                    </div>
                </div>
            </div><!-- v_if -->
            <div class="row mt-2">
                <div class="col-3 pl-4">
                    Follow-up Comments:
                </div>
                <div class="col-9">
                     {{ followupIndicator.comment }}
                </div>
            </div>
            <div class="row mt-2">
                <div class="col">
                    <div class="ml-2">Results:</div>
                    <textarea 
                        v-if="summaryIndicators" 
                        :value="summaryIndicator.result" 
                        class="form-control mt-1" 
                        :id="'result_indicator_'+ indicator.id"
                        :disabled="cycle.completed_at" 
                        placeholder="Add results here"
                        @blur="updateIndicator($event)"
                    ></textarea>
                </div>
            </div><!-- .row -->
        </div><!-- .card-body -->
    </div>
</template>

<style scoped>
.indicator-title {
    font-size: 1em;
    font-weight: 700;
    line-height: 1.4;
}
.grade-badge .badge {
    font-size: 0.9em;
    color: #fff;
}
.badge-separator {
    font-size: 1.1em;
    font-weight: bold;
}
.badge-gold {
    background-color: #D6AF36;
}
.badge-silver {
    background-color: #A7A7AD;
}
.badge-bronze {
    background-color: #A77044;
}
.details {
    font-size: 15px;
    line-height: 1.3;
}
textarea::placeholder {
    color: lightgray;
    font-style: italic;
}
</style>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'

    export default {
        props: {
            indicator: Object,
            scoringLabels: Object
        },

        components: { moment },

        methods: {
            updateIndicator (event) {
                let data = {
                    assessment_cycle_id: this.cycle.id,
                    section_number: this.indicator.section_number,
                    indicator_number: this.indicator.indicator_number,
                    result: event.target.value
                }
                this.$store.dispatch('summary/saveSummaryIndicator', data)
            },
            formatDate (date) {
                return date ? moment(date).format('MM/DD/YYYY') : null
            }
        },

        computed: {
            ...mapState({
                initialIndicators: state => state.initial.initialIndicators,
                planIndicators: state => state.plan.planIndicators,
                followupIndicators: state => state.followup.followupIndicators,
                summaryIndicators: state => state.summary.summaryIndicators,
                cycle: state => state.cycle.cycle
            }),
            initialIndicator () {
                return this.initialIndicators[this.indicator.section_number][this.indicator.indicator_number] || {}
            },
            planIndicator () {
                return this.planIndicators[this.indicator.section_number][this.indicator.indicator_number] || {}
            },
            followupIndicator () {
                return this.followupIndicators[this.indicator.section_number][this.indicator.indicator_number] || {}
            },
            summaryIndicator () {
                return this.summaryIndicators[this.indicator.section_number][this.indicator.indicator_number] || {}
            }
        }
    }
</script>
